import { useAuth, ROLE_VACATION_DP, ROLE_COLLABORATOR_ADMIN, ROLE_COLLABORATOR_EDITOR, ROLE_ADMIN } from '@/contexts/AuthContext';

export const VACATION_DP_EDITABLE_FIELDS = [
    'vacationPeriods',
    'hasPaidRest',
    'paidRestObservations',
    'paidRestPeriods',
] as const;

export function useVacationDpEditMode() {
    const { userHasRole } = useAuth();

    const hasVacationDpRole = userHasRole(ROLE_VACATION_DP);
    const hasManagementRole =
        userHasRole(ROLE_ADMIN) || userHasRole(ROLE_COLLABORATOR_ADMIN) || userHasRole(ROLE_COLLABORATOR_EDITOR);

    const isVacationDpOnly = hasVacationDpRole && !hasManagementRole;

    return {
        isVacationDpOnly,
        editableFields: VACATION_DP_EDITABLE_FIELDS,
    };
}
